import { Select } from "antd";
import * as React from "react";
import { useStoreActions, useStoreState } from "../../store/hooks/easyPeasy";
const { Option } = Select;

export interface SelectFeeSubHeadByFeeHeadSingle {
  onChange?: any;
  selected?: any;
  defaultSelected?: any;
  style?: any
}

export const SelectFeeSubHeadByFeeHeadSingle = ({
  onChange,
  selected,
  defaultSelected,
  style
}: SelectFeeSubHeadByFeeHeadSingle) => {
  const itemList = useStoreState((state) => state.saccount.feeSubHeadConfigurationList);

  
  const onSelect = (id) => {
    if (itemList) {
      const value = itemList.find((item) => item.feeSubHeadId === id);
      onChange(value.feeSubHeadId);
    }
  };

  // React.useEffect(() => {
  //   if (selected) {
  //     thanaListFetch(selected?.districtId);
  //   }
  // }, [selected])


  return (
    <Select
      onChange={onSelect}
      // loading={loading}
      showSearch
      // allowClear
      defaultValue={defaultSelected}
      value={selected}
      style={style}
      placeholder="Select Fee Subhead"
      filterOption={(input, option:any) =>
        option !== undefined &&
        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
    >
      {itemList ? (
        itemList.map((type, idx) => (
          <Option key={type.feeSubHeadId} value={type.feeSubHeadId}>
            {type.feeSubheadName}
          </Option>
        ))
      ) : (
        <Option value="fetching">Fetching Fee Subhead</Option>
      )}
    </Select>
  );
};
